// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeIn {
  from {
    bottom: 0;
    opacity: 0;
  }

  to {
    bottom: 1;
    opacity: 1;
  }
}

.BC-Toast__Container {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 20px;
  display: flex;
  justify-content: center;
  z-index: 100;
  animation: fadeIn linear 0.1s;
}

.BC-Toast {
  padding: 8px;
  background-color: #1a1a1a;
  border-radius: 0.5rem;
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.BC-Toast__with-action {
  display: flex;
}

.BC-Toast__item {
  margin: 0 8px;
}

.BC-Toast__item.BC-Toast__item-with-action {
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 20px;
}

.BC-Toast__item.BC-Toast__item-dismiss-btn {
  margin-top: 2px;
  cursor: pointer;
}

.BC-Toast__with-action .Polaris-Icon--colorBase svg {
  fill: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/toast.css"],"names":[],"mappings":"AAAA;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@keyframes fadeIn {\n  from {\n    bottom: 0;\n    opacity: 0;\n  }\n\n  to {\n    bottom: 1;\n    opacity: 1;\n  }\n}\n\n.BC-Toast__Container {\n  position: fixed;\n  width: 100%;\n  left: 0;\n  bottom: 20px;\n  display: flex;\n  justify-content: center;\n  z-index: 100;\n  animation: fadeIn linear 0.1s;\n}\n\n.BC-Toast {\n  padding: 8px;\n  background-color: #1a1a1a;\n  border-radius: 0.5rem;\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Toast__with-action {\n  display: flex;\n}\n\n.BC-Toast__item {\n  margin: 0 8px;\n}\n\n.BC-Toast__item.BC-Toast__item-with-action {\n  font-size: 14px;\n  text-decoration: underline;\n  cursor: pointer;\n  padding-left: 20px;\n}\n\n.BC-Toast__item.BC-Toast__item-dismiss-btn {\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.BC-Toast__with-action .Polaris-Icon--colorBase svg {\n  fill: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
